import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/Hero";
import ExpoSection from "@/components/ExpoSection";
import EditionsSection from "@/components/EditionsSection";
import PartnerForm from "@/components/PartnerForm";

export const HomePage = () => {
  const location = useLocation();

  // Supports cross-page nav: clicking "Éditions"/"Partenaires" from a résidence
  // tab navigates to "/" with `state: { scrollTo: "editions" }`, then this
  // scrolls once the homepage has mounted.
  useEffect(() => {
    const id = location.state?.scrollTo;
    if (!id) return;
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Hero />
      <ExpoSection />
      <EditionsSection />
      <PartnerForm />
    </>
  );
};

export default HomePage;
